module.exports = __webpack_public_path__ + "static/img/4-1-order-query-result.a8f2a73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/4-1-order-query-result.png
// module id = 1340
// module chunks = 0